import { ModuleConstants } from '@hrms/common/constant/modules';
import { RouteConstantsInterface } from '@hrms/common/constant/types';
import { ComponentsMap } from '@hrms/common/routes/components';
import { ScreenNames } from '@hrms/common/routes/screens';
import { ModuleRoutesComponentInterface } from '@hrms/common/routes/types';
import { generateImage } from '@hrms/common/utils/generateImage';

export const siteManagementBaseUrl = `/site-management`;
export const siteBaseUrl = `${siteManagementBaseUrl}/site/:id`;

export enum RouteConstantEnumsForOTManagement {
  OVERTIME_MANAGEMENT,
  SCHEDULED_OT_STATUS,
}

export const SCHEDULED_OT_URL = `${siteManagementBaseUrl}/overtime-management/schedule`;
export const CREATE_OT_URL = `${siteManagementBaseUrl}/overtime-management/create`;
export const EDIT_EMPLOYEE_URL = `${siteManagementBaseUrl}/overtime-management/employees`;

export const RouteConstantsForOT: RouteConstantsInterface = {
  OVERTIME_MANAGEMENT: `${siteManagementBaseUrl}/overtime-management`,
  SCHEDULED_OT_STATUS: `${SCHEDULED_OT_URL}/:ot_id`,
  CREATE_OT: `${CREATE_OT_URL}/:ot_id`,
  EDIT_EMPLOYEE: `${siteManagementBaseUrl}/overtime-management/employees/:ot_id`,
};

const getSiteManagementModuleRoutes: ModuleRoutesComponentInterface = () => {
  return [
    {
      id: ModuleConstants.SITE_MODULE,
      route: siteManagementBaseUrl,
      title: ScreenNames.SITE_VIEW,
      icon: generateImage({
        noScale: true,
        name: 'menu',
        alt: 'config',
        className: 'w-4 h-4',
      }),
      component: null,
      children: [
        {
          id: ModuleConstants.SITE_MANAGEMENT,
          route: `${siteManagementBaseUrl}/site`,
          title: ScreenNames.SITE_MANAGEMENT,
          component: ComponentsMap.SITE_MANAGEMENT,
          children: [
            {
              id: ModuleConstants.SITE_MANAGEMENT,
              route: siteBaseUrl,
              title: ScreenNames.SHIFT_OF_SITE_VIEW,
              component: ComponentsMap.SITE_SHIFT_MANAGEMENT,
              sidebarVisibility: false,
            },
          ],
        },
        {
          id: ModuleConstants.SHIFT_MANAGEMENT,
          route: `${siteManagementBaseUrl}/shift`,
          title: ScreenNames.SHIFT_MANAGEMENT,
          component: ComponentsMap.SHIFT_MANAGEMENT,
        },
        {
          id: ModuleConstants.AREA_MANAGEMENT,
          route: `${siteManagementBaseUrl}/area`,
          title: ScreenNames.AREA_MANAGEMENT,
          component: ComponentsMap.AREA_MANAGEMENT,
        },
        // {
        //   id: ModuleConstants.ROSTER_MANAGEMENT,
        //   route: `${siteManagementBaseUrl}/roster`,
        //   title: ScreenNames.ROSTER_MANAGEMENT,
        //   component: ComponentsMap.ROSTER_MANAGEMENT,
        // },
        {
          id: ModuleConstants.ROSTER_MANAGEMENT,
          route: `${siteManagementBaseUrl}/multi-roster`,
          title: ScreenNames.MULTI_SITE_ROSTER_MANAGEMENT,
          component: ComponentsMap.MULTI_SITE_ROSTER_MANAGEMENT,
          // children: [
          //   {
          //     id: ModuleConstants.ROASTER_PLANNING,
          //     route: `${siteManagementBaseUrl}/multi-roster/plan-roster`,
          //     title: ScreenNames.ROSTER_PLAN,
          //     component: ComponentsMap.ROSTER_PLAN,
          //     sidebarVisibility: false,
          //   },
          // ],
        },
        {
          id: ModuleConstants.OVERTIME_MODULE_ID,
          route: RouteConstantsForOT.OVERTIME_MANAGEMENT,
          title: ScreenNames.OVERTIME_MANAGEMENT,
          component: ComponentsMap.PLANNED_OT_OVERTIME,
          children: [
            {
              id: ModuleConstants.ELLIGIBLE_EMPLOYEE,
              route: RouteConstantsForOT.SCHEDULED_OT_STATUS,
              title: ScreenNames.SCHEDULED_OT_STATUS,
              component: ComponentsMap.EMPLOYEE_WITH_DIFFERENT_STATUS,
              sidebarVisibility: false,
            },
            {
              id: ModuleConstants.CREATE_OVERTIME_MODULE_ID,
              route: RouteConstantsForOT.CREATE_OT,
              title: ScreenNames.CREATE_OT,
              component: ComponentsMap.CREATE_OT,
              sidebarVisibility: false,
              children: [
                {
                  id: ModuleConstants.CREATE_OVERTIME_MODULE_ID,
                  route: RouteConstantsForOT.CREATE_OT,
                  title: ScreenNames.CREATE_PLANNED_OT,
                  component: ComponentsMap.CREATE_OT,
                  sidebarVisibility: false,
                },
                {
                  id: ModuleConstants.CREATE_OVERTIME_MODULE_ID,
                  route: RouteConstantsForOT.CREATE_OT,
                  title: ScreenNames.CREATE_ADHOC_OT,
                  component: ComponentsMap.CREATE_OT,
                  sidebarVisibility: false,
                },
              ],
            },

            {
              id: ModuleConstants.EDIT_EMPLOYEE,
              route: RouteConstantsForOT.EDIT_EMPLOYEE,
              title: ScreenNames.EDIT_EMPLOYEES,
              component: ComponentsMap.EDIT_EMPLOYEES,
              sidebarVisibility: false,
            },
          ],
        },
      ],
    },
  ];
};

export default getSiteManagementModuleRoutes;
